// Catalog labels can carry a type prefix ("STATE: Texas", "COUNTY: Texas County (MO)").
// Rank against the name after the prefix so "texas" puts the state first.
const TYPE_PREFIX = /^[A-Z_]+:\s*/;

function matchRank(label, query) {
  const full = label.toLowerCase();
  const name = label.replace(TYPE_PREFIX, "").toLowerCase();
  if (name === query || full === query) return 0;
  if (name.startsWith(query) || full.startsWith(query)) return 1;
  if (name.split(/[\s,()/-]+/).some((word) => word.startsWith(query))) return 2;
  if (full.includes(query)) return 3;
  return -1;
}

/**
 * Options whose label contains the query, best matches first: exact name,
 * then name prefix, then word prefix, then any substring. Ties keep catalog order.
 */
export function rankOptionMatches(options, query, getOptionLabel = String) {
  const normalized = String(query ?? "").trim().toLowerCase();
  if (!normalized) return options;
  return options
    .map((option, index) => ({ option, index, rank: matchRank(getOptionLabel(option), normalized) }))
    .filter((entry) => entry.rank >= 0)
    .sort((left, right) => left.rank - right.rank || left.index - right.index)
    .map((entry) => entry.option);
}
